import React, { useState, useEffect } from "react";
import imgUrl from "../../assets/images/imageUrl.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/css/customstyles.css";

import Slider from "react-slick";
import { Configuration } from "../../assets/data/config.js";

// const images = [
//   imgUrl.carousel1,
//   imgUrl.carousel2,
//   imgUrl.carousel3,
//   imgUrl.carousel4,
//   imgUrl.carousel5,
//   imgUrl.carousel6,
//   imgUrl.carousel7,
//   imgUrl.carousel8,
// ];

const axios = require('axios');

const CustomCarousel = () => {
  useEffect(() => {
    axios
      .get(Configuration.apiSurvey.key + "api/dataStore/ice/list", {
        headers: {
          // Authorization:  "Basic " + btoa("142188_healthworker1@tpttest.org" + ":" + "Test@123")
          Authorization:
            "Basic " +
            btoa("nikhil.gaikwad@duretechnologies.com" + ":" + "Dure@456"),
        },
      })
      .then((response) => {
        console.log(response.data);
        setImages(response.data.filter((img) => img.showFlag == true));
      })
      .catch((error) => {
        console.error(error);
      });
  }, [])
  const [current, setCurrent] = useState(0);
  const [images, setImages] = useState([]);
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Slider {...settings} className="custom-carousel">
        {images.map((src, index) => (
          <div
            key={index}
            className={`loginCarouselImg ${
              index === images.length - 1
                ? "last-slide"
                : index === images.length - 2
                ? "second-last-slide"
                : "loginSlides"
            }`}
          >
            <img
              src={src.url}
              alt={`Slide ${index + 1}`}
              style={{
                width: "100%",
                height: "100vh", // or a fixed height like '500px'
                objectFit: "cover",
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CustomCarousel;
